var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-module-buynowsteam"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.lang.get('copy_buynowon'))}}),_c('ViewButtonSteam')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }